<template>
	<div class="msg-model">
		<el-dialog
			:visible.sync="dialogVisible"
			:title="title"
			:width="width"
			:close-on-click-modal="false"
			:before-close="close"
		>
			<el-row :gutter="30" v-loading="loading">
				<el-col :span="12">
					<!-- 幻灯片 -->
					<carousel :list="objData.carouselList" :height="500" v-if="!objData.videoUrl"></carousel>
					<video height="500px" width="100%" :src="objData.videoUrl" v-else controls></video>
				</el-col>

				<el-col :span="12">
					<v-infinite-scroll
						:loading="reading"
						@top="prevPage"
						@bottom="nextPage"
						:offset="20"
						class="blog-details"
					>
						<!-- 详情 -->
						<social-title
							:avatarUrl="objData.avatarUrl"
							:contentFont="16"
							:dateTime="objData.dateTime"
						>
							<el-tooltip placement="bottom" :content="objData.name" slot="name">
								<div>{{ objData.name }}</div>
							</el-tooltip>
						</social-title>
						<div style="margin: 10px 0; clear: both"></div>
						<article-content
							:articleSetion="objData.articleSetion"
							:articleTranslate="objData.articleTranslate"
							@translate="translate_mode"
							ref="acricleContent"
						></article-content>
						<div style="margin: 10px 0"></div>
						<!-- 互动面板 -->
						<div style="width: 80%">
							<comment-panel
								:admire="objData.admire"
								:comment="objData.comment"
								:share="objData.share"
							></comment-panel>
						</div>
						<ig-divider></ig-divider>
						<!-- 一级评论 -->

						<template v-for="item in chatroomData">
							<chatroom
								:key="item.id"
								flag="backend"
								:avatarUrl="item.userAvatar"
								:articleSetion="item.content"
								:articleTranslate="item.articleTranslate"
								:dateTime="item.createTime"
								:id="item.id"
								:isMore="true"
								@reply="replyMsg(item.id)"
								@more="more(arguments, item)"
								@translate="translate_level(arguments, item)"
								ref="chatroom"
								v-bind="item"
							></chatroom>
							<!-- 二级评论 -->
							<template v-if="getChildren(item)">
								<div class="inner-comment" v-for="v in item.children" :key="v.id">
									<chatroom
										flag="backend"
										:avatarUrl="v.userAvatar"
										:articleSetion="v.content"
										:articleTranslate="v.articleTranslate"
										:dateTime="v.createTime"
										:id="v.id"
										@reply="replyMsg(item.id)"
										@translate="translate_level(arguments, v)"
									></chatroom>
								</div>
							</template>
							<template v-if="getChildren(item)">
								<div
									class="comment-more"
									v-loading="moreLoading"
									element-loading-spinner="el-icon-loading"
								>
									<a @click="showMore(item)">{{
										item.isNoMoreChildren ? '查看更多&gt;&gt;' : '暂无更多'
									}}</a>
								</div>
							</template>
						</template>
						<p v-loading="reading"></p>
						<p v-if="noMore" class="no-more">没有更多了...</p>
					</v-infinite-scroll>
				</el-col>
			</el-row>

			<el-row>
				<el-col :span="12" :offset="12">
					<ig-divider></ig-divider>
					<msg-input
						placeholder="我来说一说"
						:value="msgValue"
						ref="msgInput"
						@change="onchange"
						@blur="onblur"
						@focus="onfocus"
						@send="sendMsg"
					></msg-input>
				</el-col>
			</el-row>
		</el-dialog>
	</div>
</template>

<script>
import vm from '@/common/confirm.js';
import carousel from '@/components/carousel';
import commentPanel from '@/components/socialMedia/commentPanel';
import chatroom from '@/components/socialMedia/chatroom';
import msgInput from '@/components/iglobalwin/formComponents/sky-input-sendMsg.vue';
import igDivider from '@/components/client/ig-divider';
import socialTitle from '@/components/socialMedia/rowTitleCard';
import articleContent from '@/components/socialMedia/articleContent';
import tweetsAPI from '@/backend/services/account/tweets';
import { clearObjectValues } from '@/common/util.js';
import { mapState } from 'vuex';
export default {
	components: {
		carousel,
		commentPanel,
		chatroom,
		msgInput,
		igDivider,
		socialTitle,
		articleContent,
	},
	props: {
		visible: {
			type: Boolean,
			default: false,
		},
		id: {
			type: String,
			required: true,
		},
		title: {
			type: String,
			default: '帖子详情',
		},
		width: String,
	},
	data() {
		return {
			msgValue: '',
			loading: false,
			reading: false,
			displayStart: 1,
			noMore: false,
			isMore: false,
			moreLoading: false,
			objData: {
				carouselList: [],
				avatarUrl: '',
				dateTime: '',
				name: '',
				articleSetion: '',
				articleTranslate: '',
				admire: '',
				comment: '',
				share: '',
				videoUrl: '',
			},
			chatroomData: [],
			clickMoreNextNonius: null,
			nextNonius: null,
			moreComment: [],
			commentContent: '',
			cmntId: '',
			isReply: false,
		};
	},
	watch: {
		visible: {
			handler(val) {
				if (val) {
					this.reset();
					this.getBlogDetails();
				}
			},
			immediate: true,
			deep: true,
		},
	},
	computed: {
		dialogVisible() {
			return this.visible;
		},
		...mapState({
			serviceId: state => state.twitter.serviceId,
		}),
	},

	methods: {
		async getBlogDetails() {
			this.openLoading();
			let res_detail = await tweetsAPI.getTweetsShare(
				{ id: this.id },
				{ serviceId: this.serviceId }
			);
			let res_comment = this.getCommentList(this.id);
			Promise.all([res_detail, res_comment])
				.then(([res_d, res_c]) => {
					// 帖子内容
					let _data = res_d.data;
					let _msgModel = this.objData;
					_msgModel.carouselList = _data.images;
					_msgModel.avatarUrl = _data.pageAvatar;
					_msgModel.name = _data.pageName;
					_msgModel.dateTime = _data.createTime;
					_msgModel.articleSetion = _data.content;
					_msgModel.admire = _data.interactiveCount;
					_msgModel.comment = _data.commentCount;
					_msgModel.share = _data.shareCount;
					_msgModel.videoUrl = _data.videoUrl;
					// 评论列表
					if (res_c.data.length > 0) {
						res_c.data.map(item => {
							this.chatroomData.push({
								...item,
								articleTranslate: '',
								children: [],
								isNoMoreChildren: false,
								isHidden: true,
							});
						});
						this.nextNonius = res_c.page.nextNonius;
						if (res_c.page.nextNonius == '') {
							this.noMore = true;
						}
					} else {
						this.nextNonius = null;
					}
					this.closeLoading();
				})
				.catch(e => {
					this.closeLoading();
					console.error(e);
				});
		},
		/**获取评论列表
		 * @param isClickMoreNextNonius  判断是否为点击获取更多评论
		 * @property clickMoreNextNonius  二级评论下一页标记
		 * @property nextNonius   一级评论下一页标记
		 */
		async getCommentList(id, isClickMoreNextNonius) {
			let response = '';
			try {
				let res = await tweetsAPI.getCommentList(
					{ id: id },
					{ serviceId: this.serviceId },
					{
						nextNonius: isClickMoreNextNonius ? this.clickMoreNextNonius : this.nextNonius,
						displayLength: 10,
					}
				);
				if (res.status >= 200 && res.status < 400) {
					response = res.data;
				}
			} catch (error) {
				console.error(error);
			}
			return response;
		},
		/**
		 * / 下拉滚动获取评论列表
		 *  */
		async nextPage() {
			if (!this.noMore) {
				this.reading = true;
				let response = await this.getCommentList(this.id);
				if (response.data && response.data.length > 0) {
					response.data.map(item => {
						this.chatroomData.push({
							...item,
							articleSetion: '',
							children: [],
							isNoMoreChildren: false,
							isHidden: true,
						});
					});
					this.nextNonius = response.page.nextNonius;
					if (response.page.nextNonius == '') {
						this.noMore = true;
					}
				}
				this.reading = false;
			}
		},
		onfocus() {},
		// 回复
		replyMsg(id) {
			this.isReply = true;
			this.cmntId = id;
			this.$nextTick(() => {
				this.$refs.msgInput.$refs.input.focus();
			});
		},
		// 失去焦点时
		onblur() {},
		// 评论内容
		onchange(val) {
			this.commentContent = val;
		},
		// 评论
		async sendMsg(handleClearValue, handleLoading) {
			if (this.commentContent.length == 0) {
				vm._success('内容为空，不能发送。');
				handleLoading();
				return;
			}
			try {
				let res = await tweetsAPI.twitterComment(
					//评论ID  or  帖子ID
					{ id: this.isReply ? this.cmntId : this.id },
					{ serviceId: this.serviceId },
					{ content: this.commentContent }
				);

				if (res.status >= 200 && res.status < 400) {
					if (this.isReply) {
						this.isReply = false;
						/**
						 * 此处展示评论后的数据。
						 * item.isHidden 判断当前二级评论有没有展开，false：展开；然后添加一条数据至当前的二级评论中。
						 * 若没有展开，则不添加数据。只有当点击'查看更多评论'按钮后，才添加并展示二级评论。
						 */
						this.chatroomData.forEach(item => {
							if (item.id === this.id || item.id === this.cmntId) {
								if (!item.isHidden) {
									item.children.unshift({
										...res.data,
										articleSetion: '',
										children: [],
									});
								}
							}
						});
					} else {
						this.chatroomData.unshift({
							...res.data,
							articleSetion: '',
							children: [],
							isNoMoreChildren: false,
							isHidden: true,
						});
					}
					handleLoading();
					handleClearValue();
				}
			} catch (e) {
				handleLoading();
				console.error(e);
			}
		},
		getChildren(item) {
			return item.hasOwnProperty('children') && item.children.length > 0;
		},
		// 查看更多评论
		more() {
			let [id, isHidden, handleChangeText, item] = [...arguments[0], arguments[1]];
			item.isHidden = isHidden;
			this.getMoreComment(id, isHidden, handleChangeText, () => {
				item.isNoMoreChildren = true;
			});
		},
		// 查看更多>>
		showMore(item) {
			if (item.isNoMoreChildren) {
				this.moreLoading = true;
				this.getMoreComment(
					item.id,
					null,
					null,
					() => {
						item.isNoMoreChildren = true;
					},
					() => {
						item.isNoMoreChildren = false;
					}
				);
			}
		},
		/**
     * /点击获取更多评论
     *@param isHidden  控制二级评论的显示隐藏。  true 隐藏
      @param handleChangeText 更改点击的文本（查看更多评论、收起评论）
      @param handleMore  有更多数据的回调 
      @param handleNoMore  无更多数据的回调
     */
		async getMoreComment(cmntId, isHidden, handleChangeText, handleMore, handleNoMore) {
			let clickMore = true;
			if (!isHidden) {
				let response = await this.getCommentList(cmntId, clickMore);
				if (response.data.length > 0) {
					this.chatroomData.forEach(item => {
						if (item.id === cmntId) {
							response.data.map(val => item.children.push(val));
						}
					});
					this.moreLoading = false;
					this.clickMoreNextNonius = response.page.nextNonius;
					// 若还有下一页，设置isNoMoreChildren为true,说明此评论下面还有更多的二级评论。
					if (this.clickMoreNextNonius == '') {
						handleNoMore ? handleNoMore() : null;
					} else {
						handleMore ? handleMore() : null;
					}
				}
			} else {
				this.chatroomData.forEach(item => {
					if (item.id === cmntId) {
						item.children = [];
					}
				});
				this.clickMoreNextNonius = '';
			}
			handleChangeText ? handleChangeText() : null;
		},
		// 翻译
		async translate_mode(val, handleLoading) {
			val && val.length > 0
				? (this.objData.articleTranslate = await this.translate(val, handleLoading))
				: handleLoading();
		},
		async translate(val, handleLoading) {
			let content = '';
			try {
				let res = await tweetsAPI.articleTranslate({ content: val });
				if (res.status >= 200 && res.status < 400) {
					content = res.data.content;
					handleLoading();
				}
			} catch (e) {
				handleLoading();
				console.error(e);
			}
			return content;
		},
		async translate_level() {
			let [val, handleLoading, item] = [...arguments[0], arguments[1]];
			let translate = await this.translate(val, handleLoading);
			this.$set(item, 'articleTranslate', translate);
		},
		openLoading() {
			this.loading = true;
		},
		closeLoading() {
			this.loading = false;
		},
		close() {
			this.noMore = false;
			this.$emit('closed');
		},
		prevPage() {
			// this.count -= 2
		},
		reset() {
			this.objData = {
				carouselList: [],
				avatarUrl: '',
				dateTime: '',
				name: '',
				articleSetion: '',
				articleTranslate: '',
				admire: '',
				comment: '',
				share: '',
				videoUrl: '',
			};
			this.chatroomData = [];
			this.nextNonius = '';
			this.clickMoreNextNonius = '';
			this.$nextTick(() => {
				this.$refs.acricleContent.translate = false;
			});
		},
	},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '@/client/styles/variables.scss';
@import '@/client/styles/mixin.scss';
.blog-details {
	@include scrollBar_mini;
	max-height: 500px;
	overflow-y: auto;
	padding-right: 20px;
}
.inner-comment {
	padding-left: 50px;
}
.no-more {
	text-align: center;
	color: $fontColor;
	opacity: 0.5;
}
.comment-more {
	margin-bottom: 20px;
	margin-left: 100px;
	a {
		color: $fontColor;
		transition: color 0.3s;
		-webkit-transition: color 0.3s;
		opacity: 0.8;
	}
	a:hover {
		color: $blue;
	}
}
</style>
<style>
.msg-model .el-dialog__body {
	padding: 30px 20px 20px 30px;
}
.msg-model .blog-details .el-loading-spinner {
	margin-top: -8px;
	/* margin-left: -40px; */
}
.account .msg-model .el-carousel {
	position: static;
}
</style>
